import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CatalogIntegrationsSettingsPage } from "@/features/catalog-integrations";
import { GoogleWorkspaceSettingsSection } from "@/features/google-workspace";
import { SettingsPageShell } from "@/features/settings";

type ApiIntegrationsTab = "api-access" | "data-catalogs" | "google-workspace";

function ApiIntegrationsSettingsPage() {
  const [activeTab, setActiveTab] = useState<ApiIntegrationsTab>("data-catalogs");

  return (
    <SettingsPageShell
      title="API & Integrations"
      description="Manage platform access and external integration surfaces from the shared settings shell."
    >
      <Tabs value={activeTab} onValueChange={(value) => setActiveTab(value as ApiIntegrationsTab)}>
        <TabsList variant="line" className="gap-2">
          <TabsTrigger value="data-catalogs" className="px-2.5 py-1 text-sm font-semibold">
            Data Catalogs
          </TabsTrigger>
          <TabsTrigger value="google-workspace" className="px-2.5 py-1 text-sm font-semibold">
            Google Workspace
          </TabsTrigger>
          <TabsTrigger value="api-access" className="px-2.5 py-1 text-sm font-semibold">
            API Access
          </TabsTrigger>
        </TabsList>

        <TabsContent value="data-catalogs" className="pt-4">
          <CatalogIntegrationsSettingsPage />
        </TabsContent>

        <TabsContent value="google-workspace" className="pt-4">
          <GoogleWorkspaceSettingsSection />
        </TabsContent>

        <TabsContent value="api-access" className="pt-4">
          <div className="rounded-lg border border-border/70 bg-muted/20 p-4">
            <p className="text-sm font-medium">API access</p>
            <p className="mt-1 text-sm text-muted-foreground">
              API access management is planned for a later release. Data Catalogs now lives in this
              shared section so catalog administration follows the existing settings conventions.
            </p>
          </div>
        </TabsContent>
      </Tabs>
    </SettingsPageShell>
  );
}

export const Route = createFileRoute("/settings/api-integrations")({
  component: ApiIntegrationsSettingsPage,
});
